import React from 'react';
import { useAppContext } from '../appContext';
import styled, { keyframes } from 'styled-components';
import { Link } from 'react-scroll/modules';
// Icons
import { GiSunflower, GiMoon } from 'react-icons/gi';
import { FaChevronCircleUp } from 'react-icons/fa';
import PropTypes from 'prop-types';

// Animations
export const Spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const spinner = keyframes`
    to {
        transform: rotate(360deg)
    }
`;

// Loading Spinner
export const Loading = styled.div`
	display: inline-block;
	width: 5rem;
	height: 5rem;
	border: 5px solid;
	border-radius: 50%;
	border-top-color: var(--primary);
	margin: 1rem auto;
	animation: ${spinner} 0.6s linear infinite;
`;

// Spacer for fixed Navigation bar
export const FixedNavSpacer = styled.div`
	height: var(--nav-height);
`;

// Theme Toggle
const StyledSwitch = styled.label`
	/* Slider pill */
	display: flex;
	width: 3.2rem;
	font-size: 1.5rem;
	border-radius: 30px;
	transition: var(--transition);
	border: 2px solid;

	/* Hide default checkbox */
	input[type='checkbox'] {
		height: 0;
		width: 0;
		opacity: 0;
	}

	/* Move span when checked */
	input[type='checkbox']:checked + div {
		transform: translateX(100%);
	}

	div {
		display: flex;
		justify-content: center;
		align-items: center;
		transition: var(--transition);
	}
`;

export function ToggleSwitch() {
	const { theme, toggleTheme, closeExpanded } = useAppContext();

	return (
		<StyledSwitch onClick={closeExpanded} title={'Theme Selector'} alt={'Theme Selector'}>
			<input type='checkbox' aria-label={`Toggle theme, currently ${theme}.`} onClick={toggleTheme} />
			<div>{theme === 'light' ? <GiSunflower /> : <GiMoon />}</div>
		</StyledSwitch>
	);
}

// Titles
export const Title = styled.div`
	display: inline-block;
	margin: 0 auto;
	font-family: 'Arvo';
	text-align: center;

	.underline {
		height: 0.25rem;
		width: 75%;
		min-width: 3rem;
		border-radius: 0.25rem;
		background: var(--clr-primary-5);
		margin: 0 auto 1.5rem auto;
		background: ${({ theme }) => (theme.name === 'light' ? 'linear-gradient(to left, var(--primary-light), var(--primary-dark))' : 'linear-gradient(to right, var(--primary-dark), var(--primary-light))')};
	}
`;

// Back to top link
const StyledDiv = styled.div`
	position: fixed;
	bottom: calc(var(--min-footer-height) + 1.5rem);
	right: 1.5rem;
	visibility: hidden;

	.link-icons {
		color: ${({ theme }) => (theme.name === 'light' ? 'black' : '#EBECF0')};
	}

	&.show-up {
		visibility: visible;
	}
`;

export function BackToTop({ home }) {
	const [scrollY, setScrollY] = React.useState('');
	const up = React.useRef(null);

	React.useEffect(
		function () {
			function updateScrollY() {
				setScrollY(window.pageYOffset);

				if (scrollY > 1000) {
					up.current.classList.add('show-up');
				} else {
					up.current.classList.remove('show-up');
				}
			}

			window.addEventListener('scroll', updateScrollY);

			return () => window.removeEventListener('scroll', updateScrollY);
		},
		[scrollY]
	);

	return (
		<StyledDiv ref={up}>
			<Link to={home} smooth={true} duration={700} className='link-icons'>
				<FaChevronCircleUp />
			</Link>
		</StyledDiv>
	);
}

BackToTop.propTypes = {
	home: PropTypes.string.isRequired,
};
